// Util to handle get/set of local storage
// @todo: Test need for fallback to cookies
export default {
  hasStorage: localStorage && typeof localStorage.getItem === "function",

  getLocalStorage(key: string) {
    // Get value from local storage or cookies

    if (!this.hasStorage) {
      return this.getCookie(key);
    }

    var value = localStorage.getItem(key);
    return value;
  },

  setLocalStorage(key: string, value: string) {
    // Set value in local storage or cookies

    if (!this.hasStorage) {
      this.setCookie(key, value);
    }

    try {
      localStorage.setItem(key, value);
    } catch (e) {
      // Don't store for private browsing
      console.log(
        "Local Storage failed, check if browsing in Safari private window."
      );
    }
  },

  removeLocalStorage(key: string) {
    if (!this.hasStorage) {
      this.removeCookie(key);
    }
    try {
      localStorage.removeItem(key);
    } catch (e) {
      // Don't remove for private browsing
      console.log(
        "Local Storage failed, check if browsing in Safari private window."
      );
    }
  },

  getSessionStorage(key: string) {
    // Get value from Session storage or cookies

    if (!this.hasStorage) {
      return this.getCookie(key);
    }

    var value = sessionStorage.getItem(key);
    return value;
  },

  setSessionStorage(key: string, value: string) {
    // Set value in Session storage or cookies

    if (!this.hasStorage) {
      this.setCookie(key, value);
    }

    try {
      sessionStorage.setItem(key, value);
    } catch (e) {
      // Don't store for private browsing
      console.log(
        "Session Storage failed, check if browsing in Safari private window."
      );
    }
  },

  removeSessionStorage(key: string) {
    if (!this.hasStorage) {
      this.removeCookie(key);
    }
    try {
      sessionStorage.removeItem(key);
    } catch (e) {
      // Don't remove for private browsing
      console.log(
        "Session Storage failed, check if browsing in Safari private window."
      );
    }
  },

  getCookie(key: string) {
    // Get value from cookie

    var encodedName = encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&");
    var regex = new RegExp(
      "(?:(?:^|.*;)\\s*" + encodedName + "\\s*\\=\\s*([^;]*).*$)|^.*$"
    );

    return decodeURIComponent(document.cookie.replace(regex, "$1")) || null;
  },

  setCookie(key: string, value: any, days?: number, sameSite?: string, domain?: string) {
    let expires = "";
    let domainLevel = ``;
    if (domain) {
      domainLevel = `; domain=${domain}`;
    }
    let sameSiteVal = sameSite ? sameSite.toLowerCase() : false;
    let sameSiteString = `samesite=${
      (sameSiteVal && sameSiteVal == "strict") || sameSiteVal == "lax"
        ? sameSiteVal
        : "none"
    }`;
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      // @ts-ignore
      expires = "; expires=" + date.toGMTString();
    }
    document.cookie =
      key + "=" + value + ";path=/;" + sameSiteString + expires + domainLevel;
  },
  removeCookie: function (key: string) {
    this.setCookie(key, "", -1);
  },
}
